import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/components/MegaMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieChoicesButton"] */ "/opt/buildhome/repo/app/components/MetaPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/components/NewsletterForm.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
